
import React from 'react';
import CourseTemplate from '../../components/CourseTemplate';


const BMechCoursePage: React.FC = () => {
  const courseData = {
    title: "B.E. Mechanical Engineering",
    shortName: "B.E. Mech",
    duration: "4 years",
    description: "Core engineering discipline focusing on design, manufacturing, thermal systems, and mechanical systems",
    overview: "Bachelor of Engineering in Mechanical Engineering (B.E. Mech) is a 4-year undergraduate program that deals with the design, manufacturing, operation, and maintenance of mechanical systems. This course covers fundamental engineering principles including thermodynamics, fluid mechanics, materials science, manufacturing processes, and mechanical design, preparing students for diverse career opportunities in automotive, aerospace, energy, and manufacturing industries.",
    eligibility: [
      "10+2 with Physics, Chemistry, Mathematics",
      "Minimum 75% marks in JEE Main (50% for SC/ST)",
      "Valid JEE Main/State CET scores",
      "Age: Maximum 25 years (30 for SC/ST)"
    ],
    curriculum: [
      {
        year: 1,
        subjects: [
          "Mathematics-I & II",
          "Physics",
          "Chemistry",
          "Engineering Graphics",
          "Basic Mechanical Engineering",
          "Workshop Technology"
        ]
      },
      {
        year: 2,
        subjects: [
          "Strength of Materials",
          "Thermodynamics",
          "Fluid Mechanics",
          "Manufacturing Processes",
          "Materials Science",
          "Engineering Mechanics"
        ]
      },
      {
        year: 3,
        subjects: [
          "Machine Design",
          "Heat Transfer",
          "IC Engines",
          "Production Technology",
          "Control Systems",
          "Mechanical Vibrations"
        ]
      },
      {
        year: 4,
        subjects: [
          "Automobile Engineering",
          "Refrigeration & Air Conditioning",
          "Power Plant Engineering",
          "CAD/CAM",
          "Project Work",
          "Industrial Training"
        ]
      }
    ],
    careerProspects: {
      roles: [
        "Mechanical Engineer",
        "Design Engineer",
        "Production Engineer",
        "Quality Control Engineer",
        "Maintenance Engineer",
        "Project Manager",
        "R&D Engineer",
        "Automotive Engineer",
        "HVAC Engineer",
        "Manufacturing Engineer"
      ],
      industries: [
        "Automotive Industry",
        "Aerospace & Defense",
        "Manufacturing & Production",
        "Power Generation",
        "Oil & Gas",
        "Construction & Infrastructure",
        "HVAC & Refrigeration",
        "Railway & Transportation",
        "Consulting Services",
        "Research & Development"
      ],
      averageSalary: "₹3.5-12 LPA",
      topRecruiters: [
        "Tata Motors",
        "Mahindra & Mahindra",
        "Bajaj Auto",
        "L&T",
        "BHEL",
        "ISRO",
        "DRDO",
        "Maruti Suzuki",
        "Hero MotoCorp",
        "Ashok Leyland"
      ]
    },
    topColleges: [
      {
        name: "Indian Institute of Technology (IIT) Madras",
        location: "Chennai, Tamil Nadu",
        fees: "₹2,50,000/year",
        ranking: "1"
      },
      {
        name: "Indian Institute of Technology (IIT) Delhi",
        location: "New Delhi",
        fees: "₹2,50,000/year",
        ranking: "2"
      },
      {
        name: "National Institute of Technology (NIT) Trichy",
        location: "Tamil Nadu",
        fees: "₹1,50,000/year",
        ranking: "3"
      },
      {
        name: "Birla Institute of Technology (BITS) Pilani",
        location: "Rajasthan",
        fees: "₹4,50,000/year",
        ranking: "4"
      },
      {
        name: "Vellore Institute of Technology",
        location: "Tamil Nadu",
        fees: "₹1,98,000/year",
        ranking: "5"
      }
    ],
    skills: [
      "CAD Software (AutoCAD, SolidWorks, CATIA)",
      "Manufacturing Processes",
      "Thermal Analysis",
      "Material Selection",
      "Project Management",
      "Quality Control",
      "Problem-Solving",
      "Technical Drawing",
      "Finite Element Analysis",
      "Mechanical Design"
    ],
    futureScope: "Mechanical Engineering offers diverse career opportunities across traditional and emerging industries. With Industry 4.0, automation, and sustainable technologies, mechanical engineers are in demand for roles in robotics, renewable energy, electric vehicles, and smart manufacturing. Graduates can pursue higher studies, research, entrepreneurship, or leadership positions in engineering and management.",
    faqs: [
      {
        question: "What are the core subjects in Mechanical Engineering?",
        answer: "Core subjects include Thermodynamics, Fluid Mechanics, Strength of Materials, Machine Design, Manufacturing Processes, Heat Transfer, and Control Systems."
      },
      {
        question: "Which industries hire Mechanical Engineers?",
        answer: "Major industries include automotive, aerospace, manufacturing, power generation, oil & gas, construction, HVAC, and emerging sectors like renewable energy."
      },
      {
        question: "Is Mechanical Engineering still relevant in the digital age?",
        answer: "Absolutely! Mechanical Engineering is evolving with digital technologies like IoT, AI, and automation, creating new opportunities in smart manufacturing and robotics."
      },
      {
        question: "What software skills are important for Mechanical Engineers?",
        answer: "Important software includes CAD tools (AutoCAD, SolidWorks, CATIA), simulation software (ANSYS, MATLAB), and manufacturing software (CAM, PLM)."
      },
      {
        question: "Can I switch to other fields after Mechanical Engineering?",
        answer: "Yes, mechanical engineers can transition to management, consulting, finance, or pursue MBA. The analytical and problem-solving skills are valuable across sectors."
      }
    ],
    admissionProcess: [
      "JEE Main Qualification",
      "State CET Examination (for state colleges)",
      "Choice Filling & Counseling",
      "Seat Allotment",
      "Document Verification",
      "Fee Payment & Admission Confirmation"
    ]
  };

  return (
    <div className="min-h-screen w-full bg-gradient-to-br from-[#0a183d] via-black to-[#1a2746] flex flex-col items-center justify-start py-8 px-2">
      <h1 className="text-4xl md:text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 via-pink-400 to-purple-400 drop-shadow-glow animate-glow mb-8 text-center">
        {courseData.title}
      </h1>
      <div className="w-full max-w-5xl">
        <CourseTemplate courseData={courseData} />
      </div>
    </div>
  );
};

export default BMechCoursePage;
